import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';
import { IApiGridResponse } from '@api/types';
import { IApiNotificationsUserGetGridFilter, INotification } from './notificationsUser.apiService.interfaces';

export const apiNotificationsUserService = {
  getGrid: async (params: { skip?: number; take?: number }, filters: IApiNotificationsUserGetGridFilter) => {
    return await fetchApi.post<IApiGridResponse<INotification> & { pollingIntervalInSeconds: number }>(
      ApiUrls.notification.grid,
      filters,
      {
        params: { skip: params?.skip, take: params?.take },
      },
    );
  },
  get: async ({ id }: { id?: string | number }) => {
    return await fetchApi.get<INotification>(ApiUrls.notification.get, { params: { id } });
  },
  delete: async (selectedRows: number[]) => {
    return await fetchApi.post(ApiUrls.notification.delete, selectedRows);
  },
  marksAs: async (selectedRows: number[], params: { read?: boolean }) => {
    return await fetchApi.post(ApiUrls.notification.markAs, selectedRows, { params });
  },
  getEventTypes: async () => {
    return await fetchApi.get<string[]>(ApiUrls.notification.getEventTypes);
  },
  accept: async (id: number) => {
    return await fetchApi.post<void>(ApiUrls.notification.accept, null, { params: { id } });
  },
  reject: async (id: number) => {
    return await fetchApi.post<void>(ApiUrls.notification.reject, null, { params: { id } });
  },
};
